/**
 * React Query Hooks for Models
 *
 * All hooks source from the unified GET /v1/admin/models/catalog.
 * The shared `catalog` query key means every picker is served from a single fetch.
 */

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { modelsApi } from '../api';
import type { ModelCatalogResponse } from '@/types';

export const MODELS_QUERY_KEYS = {
  models: ['models'] as const,
  catalog: () => [...MODELS_QUERY_KEYS.models, 'catalog'] as const,
};

export const CATALOG_QUERY = {
  queryKey: MODELS_QUERY_KEYS.catalog(),
  queryFn: () => modelsApi.getCatalog(),
  staleTime: 1000 * 60 * 5, // 5 minutes
} as const;

/**
 * Unified model catalog — all modalities + dual descriptors (raw, unadapted).
 */
export function useModelCatalog(): UseQueryResult<ModelCatalogResponse, Error> {
  return useQuery(CATALOG_QUERY);
}
